import { Component, OnInit } from '@angular/core';
import { GroupTypes } from '@carm/_core/access-control-mgt/models';
import { AccessControlService } from '@carm/_core/access-control-mgt/services/access-control.service';
import { IKeyValue } from '@carm/_utils/models';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { TranslateService } from '@ngx-translate/core';
import { CarmResources } from '@carm/_core/access-control-mgt/models';
import { RoleTypePermissionService } from '@carm/_core/role-type-permissions/services';
import { BaseComponent } from '@carm/_utils/base.component';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'carm-most-requested-widget',
  templateUrl: './most-requested.component.html',
  styleUrls: ['./most-requested.component.scss'],
})
export class MostRequestedWidgetComponent extends BaseComponent implements OnInit {

  public links: IKeyValue[];

  constructor(protected translateService: TranslateService,
              private aclService: AccessControlService,
              private roleTypePermissionService: RoleTypePermissionService) {
    super();
  }

  ngOnInit(): void {

    this.roleTypePermissionService.getPermissions()
    .pipe(takeUntil(this.destroy$))
    .subscribe(permissions => {
      this.onPermissionsChanged();
    });

  }

  private onPermissionsChanged(): void {

    const isAllowedUpload = this.aclService.isAclAllowedResource([{resource: CarmResources.DOCUMENTS, group: GroupTypes.Editor}]);
    const isAllowedEmployeeRequests = this.aclService.isAclAllowedResource([{resource: CarmResources.EMPLOYEE, group: GroupTypes.Reader}]);
    const isAllowed3rdPartyB2BRequests = this.aclService.isAclAllowedResource([{resource: CarmResources.MANAGE_RELATIONSHIPS, group: GroupTypes.Reader}]);
    const isAllowedFinancialTransactions = this.aclService.isAclAllowedResource([{resource: CarmResources.TRANSACTION_HISTORY, group: GroupTypes.Reader}]);
    const isAllowedRulings = this.aclService.isAclAllowedResource([{resource: CarmResources.RULINGS, group: GroupTypes.Reader}]);
    const isAllowedCreateDeclaration = this.aclService.isAclAllowedResource([{resource: CarmResources.DECLARATIONS, group: GroupTypes.Manager}]);

    this.links = [];

    if (isAllowedCreateDeclaration) {
      this.links.push({
        key: RoutesConst.Declarations_Mgt_Start,
        value: this.translateService.instant('dashboard.widgets.most_requested.create_declaration'),
      });
    }

    if (isAllowedUpload) {
      this.links.push({
        key: RoutesConst.UploadDocuments_StepOne,
        value: this.translateService.instant('dashboard.widgets.most_requested.upload_document'),
      });
    }

    if (isAllowedEmployeeRequests) {
      this.links.push({
        key: RoutesConst.EmployeeAccessMgt_ManageAccessRequests,
        value: this.translateService.instant('dashboard.widgets.most_requested.manage_employee_request'),
      });
    }

    if (isAllowed3rdPartyB2BRequests) {
      this.links.push({
        key: RoutesConst.BusinessAccessMgt_B2BReceivedRequests,
        value: this.translateService.instant('dashboard.widgets.most_requested.manage_third_party_request'),
      });
    }

    if (isAllowedFinancialTransactions) {
      this.links.push({
        key: RoutesConst.Financial_TransactionHistory,
        value: this.translateService.instant('dashboard.widgets.most_requested.transaction_history'),
      });
    }

    if (isAllowedRulings) {
      this.links.push({
        key: RoutesConst.Rulings_RulingsRequests,
        value: this.translateService.instant('dashboard.widgets.most_requested.request_ruling'),
      });
    }
  }
}
